import React, { useState, useEffect } from 'react'
import './index.scss'
import { Menu } from 'antd'
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import Footer from '@/components/Footer'
import NavBottom from '@/pages/Home/NavBottom'
import Http from "@/utils/http";
import x from '@/static/svg/x.svg'
import more from '@/static/svg/more.svg'
import ConstValue from "@/utils/value";

// 递归菜单组件 - 用于手机端多层菜单
const MobileMenuItem = ({ item, level = 0, onItemClick, expandedItems, toggleExpand, addAllProducts }) => {
  const hasChildren = item.nextmenu && item.nextmenu.length > 0;
  const itemKey = `${level}-${item.menu}`;
  const isExpanded = expandedItems[itemKey];
  
  return (
    <div className={`mobile-menu-item level-${level}`}>
      <div 
        className={`menu-item-header ${hasChildren ? 'has-children' : ''}`}
        onClick={() => {
          if (hasChildren) {
            toggleExpand(itemKey);
          } else {
            onItemClick(item);
          }
        }}
      >
        <span className="menu-item-text">{item.menu}</span>
        {hasChildren && (
          <span className="toggle-icon">
            {isExpanded ? '−' : '+'}
          </span>
        )}
      </div>
      
      {hasChildren && isExpanded && (
        <div className="sub-menu-items">
          {item.nextmenu.map((child, index) => {
            // 检查是否需要添加 "All Products" 链接
            const shouldAddAllProducts = addAllProducts && child.menu === 'Pluggable Transceiver';
            
            return (
              <React.Fragment key={index}>
                <MobileMenuItem 
                  item={child}
                  level={level + 1}
                  onItemClick={onItemClick}
                  expandedItems={expandedItems}
                  toggleExpand={toggleExpand}
                  addAllProducts={false} // 只在第一层检查
                />
                {shouldAddAllProducts && (
                  <div 
                    className={`mobile-menu-item level-${level + 2} all-products-item`}
                    onClick={() => onItemClick({ link: 'productsall' })}
                  >
                    <div className="menu-item-header">
                      <span className="menu-item-text all-products-text">All Products</span>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default function Home() {
    const [current, setCurrent] = useState('home');
    const [flag, setFlag] = useState(0);
    const [showmask, setshowmask] = useState(false);
    const [mobileExpandedItems, setMobileExpandedItems] = useState({});
    const [info, setInfo] = useState([])
    const [infoImg, setInfoImg] = useState({})
    const [currentIndex, setCurrentIndex] = useState(-1);
    
    const navigate = useNavigate()
    const getParams = useParams();

    // 获取当前菜单项的子菜单数据
    const getCurrentSubMenu = () => {
        if (currentIndex === 0) return null; // Home没有子菜单
        
        // 因为第一个是Home，所以索引要减1
        const menuItem = info?.nextmenu?.[currentIndex - 1];
        return menuItem?.nextmenu || null;
    };

    const menuonClick = (index) => {
        setFlag(0)
        toPage(index.key)
        setCurrent(index.key)
    }

    const toPage = (address) => {
        if(address.indexOf('http')!==-1){
            window.open(address);
            return
        }
        setshowmask(false);
        // 重置手机端展开状态
        setMobileExpandedItems({});
        navigate('/' + address);
        window.location.reload()
    }

    // 处理手机端菜单项点击
    const handleMobileMenuItemClick = (item) => {
        if (item.link) {
            if (!item.link.includes('http')) {
                toPage(item.link);
            } else {
                window.open(item.link);
            }
        }
    };

    // 切换手机端菜单展开状态
    const toggleMobileExpand = (itemKey) => {
        setMobileExpandedItems(prev => ({
            ...prev,
            [itemKey]: !prev[itemKey]
        }));
    };

    useEffect(() => {
        if (window.location.hash === '#/home') {
            setCurrent('home')
        } else {
            setCurrent('')
            setFlag(0)
        }
    }, [getParams])

    useEffect(() => {
        getInfo("menu");
        getNextM();
        getBaceInfo();
    }, []);

    const getInfo = async (url) => {
        let res = await Http.to.items(url).readByQuery({
            sort: ['id'],
        });
    }

    const getNextM = async () => {
        let res = await Http.to.items('menu_new').readByQuery({
            sort: ['id'],
        });
        setInfo(res.data);
    }

    const getBaceInfo = async () => {
        let res = await Http.to.items('Basic_information').readByQuery({
            sort: ['id'],
        });
        setInfoImg(res.data);
    }

    const currentSubMenu = getCurrentSubMenu();

    return (
        <div className='page_home'>
            <div 
                className={current === 'home' ? "nav_home blak" : "nav_home"}  
                onMouseEnter={() => { if (current === 'home') { setCurrent(''); setFlag(1); } }} 
                onMouseLeave={() => {
                    if (flag === 1) {
                        setCurrent('home')
                    }
                }}
            >
                <div 
                    className="tag" 
                    style={{ backgroundImage: `url(${ConstValue.url + "assets/" + (current === 'home' ? infoImg?.logo : infoImg?.logocolor)})` }} 
                    onClick={() => { toPage('home') }}
                >
                </div>
                
                <div className="menu">
                    <Menu current={[current]} onClick={menuonClick} mode="horizontal">
                        {([{ menu: 'Home', link: 'home' }, ...(info?.nextmenu??[])]).map((item, index) => {
                            if(item?.status==='hide') return null;
                            return (
                                <Menu.Item key={item.link}>
                                    <div onMouseOver={() => { setCurrentIndex(index) }}>
                                        <span>{item.menu}</span>
                                    </div>
                                </Menu.Item>
                            )
                        })}
                    </Menu>
                </div>
                
                <div className='seach_icon_box'>
                    <div className="seach_icon" onClick={() => toPage('search')}>
                    </div>
                </div>
                
                <div 
                    className="seach_icon2" 
                    style={{ backgroundImage: `url(${!showmask ? more : x})` }} 
                    onClick={() => { setshowmask(!showmask) }}
                >
                </div>

                <div>
                    <div 
                        style={currentSubMenu ? { height: 'auto', opacity: '1' } : {}} 
                        className='nav_bottom_page'
                    >
                        <NavBottom 
                            type={currentIndex} 
                            menuData={currentSubMenu} 
                        />
                    </div>
                </div>
                
                <div className='mask' style={{ display: showmask ? 'flex' : 'none' }}>
                    <div className='menutop'>
                        <div className="tag" onClick={() => { toPage('home') }}>
                        </div>
                        <div className="menu">
                            <Menu current={[current]} onClick={menuonClick} mode="horizontal">
                                {([{ menu: 'Home', link: 'home' }, ...(info?.nextmenu??[])]).map((item, index) => {
                                    if(item?.status==='hide') return null;
                                    return (
                                        <Menu.Item key={item.link}>
                                            <div onMouseOver={() => { setCurrentIndex(index) }}>
                                                <span>{item.menu}</span>
                                            </div>
                                        </Menu.Item>
                                    )
                                })}
                            </Menu>
                        </div>
                        <div className='seach_icon_box'>
                            <div className="seach_icon" onClick={() => toPage('search')}>
                            </div>
                        </div>
                        <div 
                            className="seach_icon2" 
                            style={{ backgroundImage: `url(${!showmask ? more : x})` }} 
                            onClick={() => { setshowmask(!showmask) }}
                        >
                        </div>
                    </div>
                    
                    {/* 手机端多层菜单 */}
                    <div className="mobile-menu-container">
                        {info?.nextmenu?.map((item, index) => {
                            if(item?.status==='hide') return null;
                            
                            // 检查当前菜单是否为 Products，如果是，则需要在 Pluggable Transceiver 下添加 All Products
                            const isProductsMenu = item.menu === 'Products' || index === 0; // 假设第一个是 Products
                            
                            return (
                                <MobileMenuItem
                                    key={index}
                                    item={item}
                                    level={0}
                                    onItemClick={handleMobileMenuItemClick}
                                    expandedItems={mobileExpandedItems}
                                    toggleExpand={toggleMobileExpand}
                                    addAllProducts={isProductsMenu}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>

            <div className="content_home" onMouseOver={() => { setCurrentIndex(-1) }}>
                <div id={'top'}></div>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}